export enum RequirementStatusEnum {
    Pendiente = "PENDIENTE",
    Cerrado = "CERRADO",
    Compeltado = "COMPLETADO",
    Tramitado = "TRAMITADO",
    Rechazado = "RECHAZADO"
}
